// extracted by mini-css-extract-plugin
export default {"portfolioContainer":"src-styles-__portfolio__portfolioContainer__1SIh0","projectContainer":"src-styles-__portfolio__projectContainer__2yaZ2"};